<template>
  <div id="app">
    <div class="site">
      <MainNavBar @logout="$app.logout" v-if="!pathMixin_isMeeting && !pathMixin_isMeetingLandingPage" />
      <main
          class="my-6 site__content"
            :class="{
              site__padding: !pathMixin_isMeeting && !pathMixin_isMeetingLandingPage,
              'gant-together-body': pathMixin_isMeetingLandingPage
            }"
        >
        <router-view></router-view>
      </main>
      <AutoLogoutTimer @logout="$app.logout" v-if="this.$globals.profile.firstName !== ''" class="pulled-right" />
      <Footer v-if="!pathMixin_isMeeting && !pathMixin_isMeetingLandingPage" />
    </div>
  </div>
</template>

<script>
  import MainNavBar from './components/Layout/MainNavBar.vue';
  import Footer from './components/Layout/Footer.vue';
  import AutoLogoutTimer from "./components/Layout/AutoLogoutTimer";

  //the stylesheet will be imported last
  import './assets/scss/style-default.scss';

  export default {
    name: 'App',
    components: {
      Footer,
      MainNavBar,
      AutoLogoutTimer,
    },
  }
</script>